module.exports = __webpack_public_path__ + "img/header.21ea420a.png";